/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const updateObjectiveRequestSchema = z.object({
  title: z.string(),
});
